import { underscore } from '@ember/string';
import { MetricDataPoint } from './common';

export enum ChangeFromLastSign {
  Plus = '+',
  Minus = '-',
  None = '',
}
export enum ChangeFromLastTrend {
  Up = 'up',
  Down = 'down',
  None = 'none',
}
export enum ChangeFromLastPositivity {
  Positive = 'positive',
  Negative = 'negative',
}
export type ChangeFromLast = {
  change: number | null;
  sign: ChangeFromLastSign;
  trend: ChangeFromLastTrend;
};

export const IS_MEASURE_UP_TREND_POSITIVE: Record<string, boolean> = {
  sent: true,
  opened: true,
  clicked: true,
  clicked_to_opened: true,
  converted: true,
  unsubscribed: false,
  delivered: true,
  bounced: false,
  failed: false,
  suppressed: false,
  spammed: false,

  started: true,
  activated: true,
  messaged: true,
  finished: true,
  exited_early: true,
  never_activated: true,
  in_workflow: true,
};

export function changeFromLast(data: MetricDataPoint[]): ChangeFromLast | null {
  // Can't determine "change from last" trend if there aren't at least 2 data
  // points
  if (data.length < 2) {
    return null;
  }

  let [secondToLastPoint, lastPoint] = data.slice(-2);
  let lastY = lastPoint.y;
  let secondToLastY = secondToLastPoint.y;

  let change = null;
  let sign = ChangeFromLastSign.None;
  let trend = ChangeFromLastTrend.None;

  if (lastY != null && secondToLastY != null) {
    change = Math.abs(lastY - secondToLastY);
    sign = ChangeFromLastSign.Plus;

    if (lastY > secondToLastY) {
      sign = ChangeFromLastSign.Plus;
      trend = ChangeFromLastTrend.Up;
    } else if (lastY < secondToLastY) {
      sign = ChangeFromLastSign.Minus;
      trend = ChangeFromLastTrend.Down;
    }
  }

  return {
    change,
    sign,
    trend,
  };
}

export function trendPositivity(measure: string, change: ChangeFromLast | null): ChangeFromLastPositivity | null {
  if (change == null) {
    return null;
  }

  let underscoredMeasure = underscore(measure);

  let trends: Record<ChangeFromLastTrend, ChangeFromLastPositivity | null> = {
    [ChangeFromLastTrend.Up]: IS_MEASURE_UP_TREND_POSITIVE[underscoredMeasure]
      ? ChangeFromLastPositivity.Positive
      : ChangeFromLastPositivity.Negative,
    [ChangeFromLastTrend.Down]: IS_MEASURE_UP_TREND_POSITIVE[underscoredMeasure]
      ? ChangeFromLastPositivity.Negative
      : ChangeFromLastPositivity.Positive,
    [ChangeFromLastTrend.None]: null,
  };

  return trends[change.trend];
}

export function trendIconClass(positivity?: ChangeFromLastPositivity | null) {
  let classes = ['circle-trend-icon'];

  if (positivity != null) {
    classes.push(`circle-trend-icon--${positivity}`);
  }

  return classes.join(' ');
}

export function trendTextClass(positivity?: ChangeFromLastPositivity | null): string {
  if (positivity == null) {
    return '';
  }

  return {
    [ChangeFromLastPositivity.Positive]: 'text-success',
    [ChangeFromLastPositivity.Negative]: 'text-warning',
  }[positivity];
}
